import ItineraryGroup from '~/models/ItineraryGroup'
import {
	ApiCreateItineraryForm,
	ApiItineraryDay,
	ApiItinerarySpotRequest,
	ApiSpotGroup,
	APITripTask,
	ApiTripTaskAsignees,
	APITripTaskType,
} from './apiTypes'
import { Itinerary2, TRIP_PHASE, TRIP_TASK_STATE, TripTask } from '~/models/Itinerary'
import { removeEmptyValues } from '~/models/helpers/removeUndefined'
import Calendar from '~/passporter-services/shared/calendar'
import { Traveler2 } from '~/models/Traveler'
import { ItineraryDay } from '~/models/ItineraryDay'

export class ItineraryApiMapper {
	static toItineraryCreationForm(
		itinerary: Itinerary2,
		recommendedSpots?: boolean,
		origin?: string
	): ApiCreateItineraryForm {
		const apiItinerary: ApiCreateItineraryForm = {
			title: itinerary.name,
			start_date: itinerary.startDate || undefined,
			end_date: itinerary.endDate || undefined,
			num_days: itinerary.numDays,
			state: itinerary.isPrivate ? 'private' : 'public',
			destination_ids: itinerary.destinations?.map((destination) => destination.id),
			recommended_spots: recommendedSpots || false,
			origin: origin || 'other',
			cover_id: itinerary.coverId,
			num_declared_travelers: itinerary.declaredTravelers,
		}
		return apiItinerary
	}

	static toItinerarySpot(
		spotId: string,
		groupIds?: string[],
		isReference?: boolean,
		collectionId?: string
	): ApiItinerarySpotRequest {
		return {
			spot_id: spotId,
			groups_ids: groupIds,
			is_reference: isReference,
			collection_id: collectionId,
		}
	}

	static toItinerarySpots(
		spotIds: string[],
		groupIds?: string[],
		isReference?: boolean,
		collectionId?: string
	): ApiItinerarySpotRequest[] {
		return spotIds.map((spotId: string) =>
			this.toItinerarySpot(spotId, groupIds, isReference, collectionId)
		)
	}

	static toSpotGroup(group: ItineraryGroup): ApiSpotGroup {
		return {
			color: group.color!,
			text: group.name,
		}
	}

	static toTripTask(task: TripTask): APITripTask {
		const apiStatesCorrelation: Record<TRIP_TASK_STATE, APITripTaskType> = {
			[TRIP_TASK_STATE.todo]: 'todo',
			[TRIP_TASK_STATE.doing]: 'doing',
			[TRIP_TASK_STATE.done]: 'done',
		}
		const apiTask = {
			title: task.title,
			description: task.description,
			due_date: task.dueDate ? Calendar.getDateStringTwoDigit(task.dueDate) : '',
			state: apiStatesCorrelation[task.state],
		}
		return removeEmptyValues(apiTask)
	}

	static toTripTaskAssignees(assignees: Traveler2[]): ApiTripTaskAsignees {
		const assigneesIds: string[] = assignees.map((assignee: Traveler2) => assignee.id)
		return {
			user_ids: assigneesIds,
		}
	}

	static toDay(day: Partial<ItineraryDay>): Partial<ApiItineraryDay> {
		return {
			description: day.description,
			color: day.color,
			day_number: day.dayNumber,
		}
	}

	static toPhase(phase: TRIP_PHASE): undefined | TRIP_PHASE {
		if (phase === TRIP_PHASE.ALL) return
		return phase
	}
}
